import styled from "styled-components";

const CSTextInput = styled.input.attrs(() => ({
  type: "text",
  autoComplete: "off", // Prevents autocomplete dropdowns
}))`
  width: 100%;
  padding: 8px 10px;
  font-size: 16px;
  border: 2px solid var(--frame-border);
  background-color: var(--theme-colour1);
  color: var(--text-primary);
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s ease-in-out;

  &:focus {
    border-color: var(--text-primary);
  }

  &:disabled {
    background-color: var(--disabled);
    color: var(--text-disabled);
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export default CSTextInput;
